<template>
	<div>
		<div class="flex items-center justify-center gap-2 text-won-dark-blue">
			<h2 class="text-lg leading-[30px] font-semibold text-won-blue">{{ selectedRole }}</h2>
			<button @click="undoLastStepHandler">
				<PencilIcon class="size-4" />
			</button>
		</div>
		<div
			v-if="isTitleEvaluationLoading"
			class="flex h-[130px] w-full items-center justify-center"
		>
			<LoadingSpinner
				:size-in-px="38"
				:show-loading-text="false"
				:top-margin-in-px="0"
			/>
		</div>
		<RecommendationLabel
			v-else
			:message="jobTitleReasoningObject?.reasoning"
			:is-success="isStrongMatch"
			class="mt-4"
		/>
		<button
			class="
				mt-2 w-full items-center rounded-lg border border-won-green
				py-2 text-base leading-5 font-bold text-won-green
			"
			@click="undoLastStepHandler"
		>
			View All Recommendations
		</button>
	</div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { PencilIcon } from '@heroicons/vue/24/solid';
import { useJobTitleRecommenderStore } from '../../store/job-title-recommender.store';

import { steps, selectionTypes } from '../../utils/job-title-recommender';

import RecommendationLabel from './recommendation-label.vue';
import LoadingSpinner from '../library/loading-spinner.vue';

const jobTitleRecommenderStore = useJobTitleRecommenderStore();

const {
	selectedRole,
	isTitleEvaluationLoading,
	jobTitleReasoningObject,
	isStrongMatch
} = storeToRefs(jobTitleRecommenderStore);

const {
	setCurrentStep,
	setSelectedType,
	setRoleInputToConfirmedRole,
	clearSelectedOptions
} = jobTitleRecommenderStore;

const undoLastStepHandler = () => {
	clearSelectedOptions();
	setCurrentStep(steps.CHOOSE_TARGET_JOB);
	setRoleInputToConfirmedRole();
	setSelectedType(selectionTypes.INPUT);
};
</script>
